// ⚠️ PR #74 - xime: Este archivo fue restaurado al estado pre-pull (commit 4999deb).
// Cambios que hizo el PR (pendientes de revisar/integrar cuando se necesite):
// - getRules(): ahora mapea response.data en lugar de devolver el array directo
// - getRuleById(): cambio de tipo de respuesta any[] → any
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Rule } from "../../models/rules";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { RuleOutput, RuleParameter } from "./list/list.component";

@Injectable({
    providedIn: 'root'
})

export class RulesService {
    private baseUrl: string = `${environment['api_backend']}/api`
    private RulesSubject =new BehaviorSubject<Rule[]>([]);
    rule$= this.RulesSubject.asObservable();

    constructor(private http: HttpClient) {

    }

    getRules(): Observable<any[]> {
        let params = new HttpParams().set('limit', '200');
        return this.http.get<any[]>(`${this.baseUrl}/rules`, { params });
    }

    getRuleById(id: number): Observable<any> {
        return this.http.get<any[]>(`${this.baseUrl}/rules/${id}`);
    }

    createRule(rule: any): Observable<any> {
        console.log('rule', rule)
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<any>(`${this.baseUrl}/rules`, rule, { headers })
            .pipe(
                tap(d => console.log(d))
            );
    }

    updateRule(ruleId: number, ruleData: any): Observable<any> {
        const url = `${this.baseUrl}/rules/${ruleId}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.patch<any>(url, ruleData, { headers })
    }

    deleteRule(ruleId:number): Observable<Rule> {
    return this.http.delete<Rule>(`${this.baseUrl}/rules/${ruleId}`)
    } 

    deleteParameter(rule_parameter_id: number): Observable <RuleParameter> {
        return this.http.delete<RuleParameter>(`${this.baseUrl}/rule-parameters/${rule_parameter_id}`)
    }

    deleteOutput(rule_output_id: number): Observable <RuleOutput>{
    return this.http.delete<RuleOutput>(`${this.baseUrl}/rule-outputs/${rule_output_id}`)
    }

    cloneRule(rule_id: number) {
        console.log('datos que se envian',  )
        const header = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.get<any>(`${this.baseUrl}/rules/clone/${rule_id}`)
    } 
}